import React, { Component } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const Unauthorized = (props) => {
    const { t, i18n } = useTranslation();
    return (
        <div class="py-5">
            <div class="container py-5">
                <div class="row">
                    <div class="col-md-2 text-center">
                        <p><FontAwesomeIcon icon={faExclamationTriangle} className="fa-5x text-danger" /><br />{t('Status Code')}: 403</p>
                    </div>
                    <div class="col-md-10">
                        <h3><b>403</b> {t('Unauthorized')}</h3>
                        <p>{t('You do not have permissions to access this resource using your current credentials.')}</p>
                        <a class="btn btn-secondary" href="/auth/logout">{t('Logout')}</a>&nbsp;
                            <a class="btn btn-primary" href="javascript:history.back()">{t('Go back')}</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Unauthorized;